module.exports = __webpack_public_path__ + "static/dancers-no-background-968a6fa5f64526c769f7746d8578b01e.png";